import { LOGIN_ACTION, LOGIN_SUCCESS, LOGOUT } from "./sign-in.constants";

export const login = (payload = {}, callback) => ({type: LOGIN_ACTION, payload, callback});
export const setLoginSuccess = () => ({type: LOGIN_SUCCESS, payload: {isLoggedIn: true}});
export const logout = () => ({type: LOGOUT, payload: {isLoggedIn: false}});